import { CanActivateFn, Router } from '@angular/router';

export const PublicPanelGuard: CanActivateFn = (route, state) => {
  const router = new Router;
  const token = sessionStorage.getItem('token');

  if (token) {
    router.navigate(['/panel']);
    return true;
  }
  return true;
};
